import ria from './ria'
import rira from './rira'

export default [
    {
        path: 'integracao',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...ria,
            ...rira,
        ],
    },
]